
import { Dialog, DialogTitle, DialogContent, List, ListItem, ListItemAvatar, Avatar, ListItemText, Typography, DialogActions, Button, Grid, CircularProgress, DialogContentText, Box } from "@mui/material";

import PersonIcon from '@mui/icons-material/Person';

import { SolicitudesProps } from "../interfaces/comun/SolicitudInterface";
import { useEffect, useState } from "react";
import { ObtenerConteoSolicitudes } from "../connections/comun/AgendaConnection";

interface Props {
    open: boolean;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export const DialogSolicitudes = ({ open, setOpen }: Props) => {

    const [solicitudes, setSolicitudes] = useState<SolicitudesProps[]>([])
    const [loadingData, setLoadingData] = useState(true);

    useEffect(() => {

        async function Obtener() {

            setLoadingData(true)

            setSolicitudes([])

            await ObtenerConteoSolicitudes().then(resp => {

                setTimeout(() => {

                    setSolicitudes(resp);

                    setLoadingData(false)

                }, 700);

            });

        }

        if( open ){
            Obtener()
        }


    }, [open])

    return (
        <Dialog
            open={open}
            onClose={() => { }}
            disableEscapeKeyDown
        >
            <DialogTitle>
                Solicitudes para fecha de audiencia
            </DialogTitle>

            <DialogContent sx={{ width: 450,  }}>

                {
                    loadingData
                    ?
                        <Grid size={12} textAlign={'center'} alignContent={'center'} height={250}>
                            <CircularProgress size={32} />
                        </Grid>
                    :
                        <List disablePadding sx={{ width: '100%', bgcolor: 'background.paper' }}>

                            {
                                solicitudes.map((e , index) => (
                                    

                                    <ListItem key={index} alignItems="flex-start" disableGutters divider>
                                        
                                        <ListItemAvatar>
                                            <Avatar>
                                                <PersonIcon color="secondary" fontSize="medium" />
                                            </Avatar>
                                        </ListItemAvatar>

                                        <ListItemText
                                            primary={<Typography fontSize={16} variant="h6">{e.juez?.toUpperCase() ?? "" }</Typography>}
                                            secondary={`Número de solicitudes: ${e.numeroSolicitudes}`}
                                        />

                                    </ListItem>

                                ))
                            }

                        </List>
                }

                {
                    ( solicitudes.length === 0 && !loadingData )
                    &&
                        <Box  textAlign={'center'}>
                            <DialogContentText my={10}>No se encontraron solicitudes</DialogContentText>
                        </Box>
                }

            </DialogContent>

            <DialogActions>

                <Button onClick={() => setOpen(false)}>
                    Cancelar
                </Button>

            </DialogActions>

        </Dialog>
    )
}
